/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feToggleLeft', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherToggleLeftIconData */

/** @type {FeatherToggleLeftIconData} */
const feToggleLeft = {
  prefix: 'fe',
  iconName: 'toggle-left',
  icon: [
    24,
    24,
    '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-toggle-left"><path d="M8 5 H16 A7 7 0 0 1 23 12 V12 A7 7 0 0 1 16 19 H8 A7 7 0 0 1 1 12 V12 A7 7 0 0 1 8 5 z"/><path d="M11 12 A3 3 0 0 1 8 15 A3 3 0 0 1 5 12 A3 3 0 0 1 11 12 z"/></svg>',
    'M8 5 H16 A7 7 0 0 1 23 12 V12 A7 7 0 0 1 16 19 H8 A7 7 0 0 1 1 12 V12 A7 7 0 0 1 8 5 z M11 12 A3 3 0 0 1 8 15 A3 3 0 0 1 5 12 A3 3 0 0 1 11 12 z',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feToggleLeft
